module.exports = __webpack_public_path__ + "static/img/getInvitationBonusBox.7f9bb90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/getInvitationBonusBox.png
// module id = rzCY
// module chunks = 0